export const isExternal = (url: string) => {
  try {
    const newUrl = new URL(url);
    return newUrl.hostname !== window.location.hostname;
  } catch (error) {
    return false; // Invalid URL
  }
};
